/**
 * CONFIDENTIAL AND PROPRIETARY SOURCE CODE.
 * Use and distribution of this code is subject to applicable licenses and the
 * permission of the code owner. This notice does not indicate the actual or
 * intended publication of this source code.
 *
 * Portions developed for Bronner's Christmas by BTM Global Consulting LLC and are the
 * property of Bronner's Christmas.
 * =============================================================================
 * Version  Date          Author        Remarks
 * 1.0.0    3 Aug 2021    Tuan Le       BZ45372 - [Bronner] [SBOX & PROD] Retail - Add Recently Viewed Items to PDP Page
 */

define(
    'BTM.PDPRecentlyViewedItems.PDPRecentlyViewedItems'
    , [
        'SC.Configuration',
        'ProductDetails.Full.View',
        'RecentlyViewedItems.View'
    ]
    , function (
        Configuration,
        ProductDetailsFullView,
        RecentlyViewedItemsView
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                if (!Configuration.get('pdpRecentlyViewedItems.enabled')) {
                    return;
                }
                ProductDetailsFullView.addChildViews({
                    'RecentlyViewed.Items': function wrapperFunction() {
                        return function () {
                            return new RecentlyViewedItemsView({
                                application: container
                            });
                        };
                    }
                });
            }
        };
    });
